<div class="psv">
  <div class="psv__card" [class.psv__card--frame]="step === 'qr-code'">
    <img class="psv__logo" [src]="logoSrc" alt="" />

    <ng-container [ngSwitch]="step">
      <div class="psv__content" *ngSwitchCase="'action-required'">
        <img class="psv__illustration" src="assets/logos/signature-logo.png" alt="" />

        <h2 class="psv__title">
          {{ "physician-signature-validation.action-required.title" | translate }}
        </h2>

        <p class="psv__description">
          {{ "physician-signature-validation.action-required.description" | translate }}
        </p>

        <button
          libButton
          appearance="primary"
          type="button"
          class="psv__button"
          [disabled]="!qrCodeUrl"
          (click)="validateWithQrCode()"
        >
          {{ "physician-signature-validation.actions.validate-qr" | translate }}
        </button>

        <button libButton appearance="outline" type="button" class="psv__button" (click)="cancel()">
          {{ "physician-signature-validation.actions.cancel" | translate }}
        </button>
      </div>

      <div class="psv__content" *ngSwitchCase="'certificate-instructions'">
        <img class="psv__illustration" src="assets/logos/signature-logo2.png" alt="" />

        <h2 class="psv__title">
          {{ "physician-signature-validation.certificate-instructions.title" | translate }}
        </h2>

        <p class="psv__description">
          {{ "physician-signature-validation.certificate-instructions.description-prefix" | translate }}
          <a [href]="vidaasAppleStoreUrl" target="_blank" rel="noopener noreferrer">
            <strong>{{ "physician-signature-validation.certificate-instructions.apple-store" | translate }}</strong>
          </a>
          {{ "physician-signature-validation.certificate-instructions.description-separator" | translate }}
          <a [href]="vidaasGooglePlayUrl" target="_blank" rel="noopener noreferrer">
            <strong>{{ "physician-signature-validation.certificate-instructions.google-play" | translate }}</strong> </a
          >{{ "physician-signature-validation.certificate-instructions.description-suffix" | translate }}
        </p>

        <ol class="psv__steps">
          <li>{{ "physician-signature-validation.certificate-instructions.step-1" | translate }}</li>
          <li>{{ "physician-signature-validation.certificate-instructions.step-2" | translate }}</li>
          <li>
            {{ "physician-signature-validation.certificate-instructions.step-3-prefix" | translate }}
            <strong>{{ "physician-signature-validation.actions.already-registered" | translate }}</strong>
          </li>
        </ol>

        <button
          libButton
          appearance="primary"
          type="button"
          class="psv__button"
          (click)="confirmCertificateRegistration()"
        >
          {{ "physician-signature-validation.actions.already-registered" | translate }}
        </button>

        <button libButton appearance="outline" type="button" class="psv__button" (click)="goBack()">
          {{ "actions.back" | translate }}
        </button>

        <p class="psv__error" *ngIf="certificateStillInvalid">
          {{ "physician-signature-validation.certificate-instructions.still-invalid" | translate }}
        </p>
      </div>

      <div class="psv__frame-wrapper" *ngSwitchCase="'qr-code'">
        <iframe class="psv__frame" title="Vidaas" [src]="safeQrCodeUrl" (load)="onVidaasFrameLoad($event)"></iframe>
      </div>

      <div class="psv__content" *ngSwitchCase="'processing'">
        <mat-spinner diameter="50"></mat-spinner>
        <p class="psv__description">
          {{ "physician-signature-validation.processing" | translate }}
        </p>
      </div>

      <div class="psv__content" *ngSwitchCase="'error'">
        <img class="psv__illustration" src="assets/logos/404-error.png" alt="" />

        <h2 class="psv__title">
          {{ "physician-signature-validation.error.title" | translate }}
        </h2>

        <p class="psv__description">
          {{
            (redirectsToLogin
              ? "physician-signature-validation.error.description-login"
              : "physician-signature-validation.error.description"
            ) | translate
          }}
        </p>

        <span class="psv__countdown">{{ formattedCountdown }}</span>
      </div>
    </ng-container>
  </div>

  <span class="psv__version">{{ "nouns.version" | translate }} {{ appVersion }}</span>
</div>
